// @flow

import React from 'react';
import type { SearchContainerState } from './types';

const SearchContext = React.createContext<SearchContainerState>({
  results: [],
  translations: {},
  filters: {},
  setFilters: () => {},
});

export default SearchContext;
